module.exports = __webpack_public_path__ + "static/page-404-361fe6651b3319eb167f90a717248268.svg";